module.exports = __webpack_public_path__ + "img/spotify2.82a07222.svg";